/* Joeydolls culture pages: add-to-cart for jd cards (uses the theme cart drawer when present) */
(function () {
  if (window.jdCultureReady) return;
  window.jdCultureReady = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jd-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(btn.getAttribute('data-jd-atc'), 10), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw res;
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          var item = (res.items && res.items[0]) || {};
          item.sections = res.sections;
          drawer.classList.remove('is-empty');
          drawer.renderContents(item);
          btn.textContent = 'Added';
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        btn.textContent = (err && err.description) ? 'Unavailable' : 'Try again';
      })
      .finally(function () {
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
      });
  });
})();
